(function(){
  // rotating announcement bar
  var bar = document.querySelector('[data-announcement]');
  if(bar){
    var items = bar.querySelectorAll('.announcement__item');
    if(items.length > 1){
      var i = 0;
      setInterval(function(){
        items[i].classList.remove('is-active');
        i = (i+1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    }
  }
  // mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if(toggle && menu){
    toggle.addEventListener('click', function(){ menu.classList.toggle('is-open'); });
  }
})();
